<template>
  <el-menu
      :default-active="activeMenu"
      class="side-menu"
      background-color="transparent"
      text-color="rgba(255,255,255,0.78)"
      active-text-color="#ffffff"
      @open="handleOpen" @close="handleClose" :collapse="false">
    <router-link to="/TeacherIndex">
      <el-menu-item index="Index" @click="selectMenu({name: 'TeacherIndex', title: '首页'})">
        <template slot="title">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </template>
      </el-menu-item>
    </router-link>
    <el-submenu :index="menu.name" v-for="menu in menuList" :key="menu.title">
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{ menu.title }}</span>
      </template>
      <router-link :to="item.path" v-for="item in menu.children" :key="item.name">
        <el-menu-item :index="item.name" @click="selectMenu(item)">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </template>
        </el-menu-item>
      </router-link>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  name: "SideMenu",
  data() {
    return {}
  },
  computed: {
    activeMenu() {
      return this.$route.name || 'TeacherIndex'
    },
    menuList: {
      get() {
        return this.$store.state.menus.menuList
      }
    }
  },
  methods: {
    selectMenu(item) {
      this.$store.commit("addTab", item)
    },
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    }
  }
}
</script>

<style scoped>
.side-menu {
  height: 100%;
  width: 224px;
  padding: 14px 12px;
  overflow-x: hidden;
  overflow-y: auto;
  border-right: 0;
}

.side-menu::-webkit-scrollbar {
  width: 6px;
}

.side-menu::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.28);
}

.side-menu::-webkit-scrollbar-track {
  background: transparent;
}

.side-menu >>> .el-menu-item,
.side-menu >>> .el-submenu__title {
  height: 46px;
  line-height: 46px;
  margin: 4px 0;
  border-radius: 12px;
}

.side-menu >>> .el-menu-item i,
.side-menu >>> .el-submenu__title i {
  color: rgba(255, 255, 255, 0.68);
}

.side-menu >>> .el-menu-item.is-active {
  color: #fff !important;
  background: linear-gradient(135deg, rgba(42, 165, 220, 0.9), rgba(24, 120, 189, 0.9)) !important;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
}

.side-menu >>> .el-menu-item:hover,
.side-menu >>> .el-submenu__title:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

@media (max-width: 900px) {
  .side-menu {
    width: 100%;
    height: auto;
    max-height: none;
    overflow: visible;
    padding: 8px;
  }
}
</style>
